import request from '@/utils/request'
// import debugLog from '@/utils/debugLog'

export function getBankAccounts(params) {
  // debugLog(params)
  return request({
    url: '/bank_accounts',
    method: 'get',
    params: params
  })
}

export function getBankAccount(id) {
  return request({
    url: `/bank_accounts/${id}`,
    method: 'get'
  })
}

export function patchBankAcount(record) {
  return request({
    url: '/bank_accounts/' + record.id,
    method: 'patch',
    data: record
  })
}

export function postBankAcount(record) {
  return request({
    url: '/bank_accounts/',
    method: 'post',
    data: record
  })
}
